'use client';
import React from 'react';
import Container from '@src/components/Shared/Container';
import SectionHeader from '@src/components/Shared/SectionHeader';
import RenderBodyCopy from '@src/components/Shared/RenderBodyCopy';
import RenderButtons from '@src/components/Shared/RenderButtons';
import InlineSVG from '@src/components/Shared/InlineSVG';

import useHumanTrakTilesAnimate from './useHumanTrakTilesAnimate';
import { HumanTrakVideoPropTypes } from './HumanTrakVideo.types';

export default function HumanTrakVideo({ data, id }: HumanTrakVideoPropTypes) {
  const { containerRef, videoRef } = useHumanTrakTilesAnimate();

  return (
    <div id={id} className=''>
      <Container className='pb-[7.4rem] md:flex md:flex-col lg:pt-[7.4rem]'>
        <SectionHeader
          className='z-101 justify-center md:mb-[3.4rem] lg:pb-[unset]'
          pretitle={data?.preTitle}
          title={data?.title}
          titleClassName='max-w-[71.6rem] text-[2.8rem] xl:text-[4.8rem] mb-[2.4rem] leading-[3.2rem] md:leading-[4.6rem] xl:leading-[5rem] font-light'
          align='center'
        >
          <>
            <RenderBodyCopy className='2xl:max-w-[78.2rem]' bodyCopy={data?.bodyCopy?.json?.content} />
            <RenderButtons className='justify-start! md:justify-center!' items={data?.buttonCollection?.items} />
          </>
        </SectionHeader>

        <div ref={containerRef} className='relative mt-[3rem] md:mt-[-5rem] xl:mt-[-10rem]'>
          <video ref={videoRef} src={data?.mediaPrimary?.url} className='lg:mb-[unset]' muted playsInline />
          {/* Camera and tripod description desktop and mobile */}
          <InlineSVG
            src={data?.extraAssetsCollection?.items?.[0]?.media?.url}
            className='humantrak-tile-animate absolute! top-[52%] left-[-2%] hidden w-[22rem] opacity-0 lg:block 2xl:w-[30rem]'
            renderAt={['desktop']}
          />
          <InlineSVG
            src={data?.extraAssetsCollection?.items?.[1]?.media?.url}
            className='humantrak-tile-animate xsm:left-[2%] xsm:top-[16%] absolute! top-[14%] left-[-4%] w-[10rem] opacity-0 sm:left-[2%] sm:w-[12rem] md:top-[18%] md:left-[4%] md:w-[15rem] lg:hidden'
            renderAt={['tablet', 'mobile']}
          />
          {/* Hard case travel description */}
          <InlineSVG
            src={data?.extraAssetsCollection?.items?.[2]?.media?.url}
            className='humantrak-tile-animate absolute! top-[30%] left-[59%] w-[15rem] opacity-0 sm:w-[17rem] md:w-xs lg:top-[33%] lg:left-[60%] lg:w-md 2xl:w-xl'
            renderAt={['desktop', 'tablet', 'mobile']}
          />
          {/* Custom laptop description */}
          <InlineSVG
            src={data?.extraAssetsCollection?.items?.[3]?.media?.url}
            className='humantrak-tile-animate 3xl:top-[44%] absolute! top-[38%] left-[70%] w-[12rem] opacity-0 sm:top-[39%] sm:left-[73%] sm:w-[14.5rem] md:top-[40%] md:left-[73%] md:w-[19rem] lg:top-[41%] lg:left-[75%] lg:w-[26rem] 2xl:w-[34rem]'
            renderAt={['desktop', 'tablet', 'mobile']}
          />
          {/* Wireless keyboard description */}
          <InlineSVG
            src={data?.extraAssetsCollection?.items?.[4]?.media?.url}
            className='humantrak-tile-animate absolute! top-[85%] left-[60%] w-[9rem] opacity-0 sm:w-[11rem] md:w-[15rem] lg:top-[85%] lg:w-xs 2xl:left-[65%] 2xl:w-[25rem]'
            renderAt={['desktop', 'tablet', 'desktop']}
          />
        </div>
      </Container>
    </div>
  );
}
